"use client";

import React from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MagicInEveryBite() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="88113" id="artikel-opini-unggulan" className="relative bg-white border-b border-[#E5E5E5] overflow-hidden min-h-[85vh] md:min-h-[70vh] flex items-center py-20 md:py-24 lg:py-32">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[30rem] sm:text-[30rem] md:text-[60rem] lg:text-[80rem] font-sans italic text-[#EB7C2D] opacity-[0.03] leading-none translate-x-1/4 lg:translate-x-0">
          O
        </span>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="flex flex-col md:flex-col lg:flex-row items-center gap-16 md:gap-8 lg:gap-12">
          
          {}
          <div ref={textRef} className={`w-full md:w-[70%] lg:w-[60%] flex flex-col items-start text-left space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="text-3xl sm:text-3xl md:text-5xl lg:text-[44px] font-sans text-black font-bold leading-tight tracking-tighter">
              <span className="bg-[#EB7C2D] text-white text-xs px-3 py-1 rounded-sm mb-4 inline-block uppercase tracking-widest font-sans font-bold">Opini Unggulan</span><br />
              Menakar Masa Depan Demokrasi Digital di Indonesia
            </h1>
            
            <p className="text-[16px] sm:text-[16px] md:text-[18px] lg:text-[20px] text-[#4A3728] max-w-2xl font-sans font-normal leading-relaxed line-clamp-3">
              Analisis mendalam mengenai pergeseran paradigma sosial dalam menanggapi arus informasi yang kian deras di tengah masyarakat modern serta dampaknya terhadap kebijakan publik di masa depan.
            </p>
            
            <div className="flex flex-wrap items-center gap-4 pt-4">
              <Button asChild size="lg" className="rounded-[4px] px-8 h-12 sm:h-12 md:h-14 text-base md:text-lg bg-[#EB7C2D] text-white hover:bg-[#EB7C2D]/90 shadow-lg shadow-[#EB7C2D]/20 transition-all hover:scale-105">
                <Link to="#">Baca Selengkapnya</Link>
              </Button>
              
              <Button asChild variant="ghost" size="lg" className="rounded-[4px] px-8 h-12 sm:h-12 md:h-14 text-base md:text-lg text-[#4A3728] font-bold hover:bg-[#EB7C2D]/5 transition-all">
                <Link to="#">
                  <Play className="mr-2 size-5 fill-[#4A3728]/20" />
                  Redaksi Opini
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full md:w-[45%] lg:w-[40%] max-w-md lg:max-w-lg mx-auto relative mt-8 sm:mt-8 lg:mt-0">
            <style>{`
              @keyframes float-cake {
                0% { transform: translateY(0px) rotate(0deg); }
                50% { transform: translateY(-10px) rotate(0.5deg); }
                100% { transform: translateY(0px) rotate(0deg); }
              }
              .animate-float-cake {
                animation: float-cake 6s ease-in-out infinite;
              }
            `}</style>
            
            <div className="relative animate-float-cake sm:[animation-duration:4s]">
              {}
              <div className="absolute inset-0 bg-[#EB7C2D]/5 rounded-[6px] blur-[80px] transform scale-90 translate-y-10 -z-10"></div>
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/editorial_portrait.png" alt="Editorial Portrait" className="w-full h-auto object-cover rounded-[6px] shadow-inner drop-shadow-xl" loading="eager" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}